import { render, staticRenderFns } from "./KvmDockerContainers.vue?vue&type=template&id=d06598ca&scoped=true&"
import script from "./KvmDockerContainers.vue?vue&type=script&lang=js&"
export * from "./KvmDockerContainers.vue?vue&type=script&lang=js&"
import style0 from "./KvmDockerContainers.vue?vue&type=style&index=0&id=d06598ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d06598ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d06598ca')) {
      api.createRecord('d06598ca', component.options)
    } else {
      api.reload('d06598ca', component.options)
    }
    module.hot.accept("./KvmDockerContainers.vue?vue&type=template&id=d06598ca&scoped=true&", function () {
      api.rerender('d06598ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/services/hosting/kvm/KvmDockerContainers.vue"
export default component.exports